import { IconWrapper } from '../runtime';
export default IconWrapper('pic-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.25C24 22.3211 22.3211 24 20.25 24H3.75C1.67893 24 0 22.3211 0 20.25V3.75Z",
      "fill": 'url(#' + props.id + 'bd859f4f' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M19.35 6.5625C19.35 7.39093 18.6784 8.0625 17.85 8.0625C17.0215 8.0625 16.35 7.39093 16.35 6.5625C16.35 5.73407 17.0215 5.0625 17.85 5.0625C18.6784 5.0625 19.35 5.73407 19.35 6.5625ZM16.4117 11.4966C16.129 11.0584 15.4964 11.0353 15.1826 11.4517L13.4169 13.7942L10.3652 9.62C10.0601 9.20265 9.43415 9.2119 9.1415 9.63808L3.81651 17.3927C3.6455 17.6417 3.82412 17.9804 4.12623 17.98L5.82543 17.9773C6.07105 17.9769 6.30092 17.8563 6.44078 17.6544L9.7406 12.8906L12.644 16.8818C12.9341 17.2805 13.5233 17.2957 13.8335 16.9125L14.5708 16.0017L15.6563 14.6719L17.7017 17.6388C17.8417 17.8418 18.0726 17.9631 18.3192 17.9631H19.8952C20.1921 17.9631 20.3713 17.6343 20.2103 17.3848L16.4117 11.4966Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + 'bd859f4f',
      "x1": "0",
      "y1": "0",
      "x2": "28.4907",
      "y2": "16.0072",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#6383FF"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#4551FF"
    }
  })])])]);
});